<label
  [class.has-error]="required() && !state().checked()"
  [class.disabled]="disabled()"
  [ngClass]="color()">
  @if (formControlRef()) {
    <input
      type="checkbox"
      class="accredible-checkbox"
      [attr.data-cy]="dataCy()"
      [formControl]="formControlRef()"
      [checked]="checked()"
      [attr.aria-label]="label()"
      [attr.aria-checked]="state().checked()"
      [attr.aria-describedby]="hint() || ''"
      [attr.aria-disabled]="disabled()"
      (change)="onChange($event)" />
  } @else {
    <input
      type="checkbox"
      class="accredible-checkbox"
      [attr.data-cy]="dataCy()"
      [checked]="checked()"
      [attr.aria-label]="label()"
      [attr.aria-checked]="state().checked()"
      [attr.aria-describedby]="hint() || ''"
      [attr.aria-disabled]="disabled()"
      (change)="onChange($event)" />
  }

  <span class="input-box">
    <accredible-icon class="font-xs-regular" [icon]="'check'" />
  </span>

  <span class="input-text font-multiline-normal-regular" [innerHTML]="label()"></span>
</label>

@if (hint()) {
  <div class="hint font-s-regular">
    {{ hint() }}
  </div>
}
